<img
  class="file-icon"
  data-testid="image"
  [src]="iconUrl() | fileHash"
  [alt]="extension()"
/>
